import React, { useEffect, useRef, useState} from 'react';
import LandingPage from './landing/LandingPage';
import { Routes, Route } from 'react-router';
import Home from './Home';
import FilterResults from './results/FilterResults';
import UserLayout from './UserLayout';
import GroupPage from './PlaylistGroups/GroupPage';
import PlaylistPage from './PlaylistGroups/PlaylistPage';
import Categories from './categories/Categories';
import { useDispatch, useSelector } from 'react-redux';
import { getPlaylistGroups, listUserPlaylists } from '../actions/PlaylistActions';
import CategoryResults from './results/CategoryResults';
import UserPlaylistPage from './PlaylistGroups/UserPlaylistPage';
import PlaylistsUser from './PlaylistGroups/PlaylistsUser';
import NewSearchPage from './search/NewSearchPage';


function UserContent() {


    const dispatch = useDispatch()

    const groupsRef = useRef()

    const scrollRef = useRef(null);

    const { user, userLoading } = useSelector(state=>state.user)

    const [activeGroup, setActiveGroup] = useState()

    const [filterList, setFilterList] = React.useState([])

    const [activeComponent, setActiveComponent] = React.useState(1)


    useEffect(()=>{
        if(user && user.id){
            dispatch(listUserPlaylists())
        }
    },[user])

    useEffect(()=>{
        dispatch(getPlaylistGroups())
    },[])

  return (
    <>
      <Routes>
        <Route element = {
            <UserLayout
                scrollRef={scrollRef}
            /> } >
            <Route exact path = '/' element = {
                <LandingPage
                    activeGroup={activeGroup}
                    setActiveGroup={setActiveGroup}
                    groupsRef={ groupsRef}
                    setFilterList={setFilterList}
                    setActiveComponent={setActiveComponent}
                /> }
            />
            <Route path = '/home' element = {
                <Home
                    activeGroup = {activeGroup}
                    setActiveGroup={setActiveGroup}
                    groupsRef={ groupsRef}
                    user = {user}
                    userLoading = {userLoading}
                    setFilterList = {setFilterList}
                    setActiveComponent = {setActiveComponent}
                    filterList={filterList}
                />
                }
            />
            <Route path = '/category' element = {
                <Categories/>
                }
            />
            <Route path = '/category/:category_title/:category_id' element = {
                <CategoryResults />
                }
            />
            <Route path = '/filter_results/:filterList' element = {
                <FilterResults/>
                }
            />
            <Route path = '/group/:group_id/:group_title' element = {
                <GroupPage/>
                }
            />
            <Route path = '/myPlaylists' element = {
                <PlaylistsUser/>
                }
            />
            <Route path = '/playlist/:playlist_id/:playlist_title' element = {
                <PlaylistPage/>
                }
            />
            <Route path = '/search' element = {
                <NewSearchPage
                    filterList = {filterList}
                    setFilterList = {setFilterList}
                    activeComponent = {activeComponent}
                    setActiveComponent = {setActiveComponent}
                    scrollRef={scrollRef}
                />
                }
            />
            <Route path = '/myPlaylist/:playlist_id/:playlist_title' element = {
                <UserPlaylistPage/>
                }
            />
        </Route>
      </Routes>
    </>
  )
}


export default UserContent;

